interface ShouldRunDataLoadParams {
  initData?: boolean;
  shortId?: string | null;
  hasSurveyData: boolean;
  loadedShortId: string | null;
  loadedAid: string | null;
  loadedUuid: string | null;
  currentAid: string | null;
  currentUuid: string | null;
  isRunInFlight: boolean;
}

interface DataLoadContextParams {
  loadedShortId: string | null;
  loadedAid: string | null;
  loadedUuid: string | null;
  currentShortId: string | null | undefined;
  currentAid: string | null;
  currentUuid: string | null;
}

export function isSameDataLoadContext({
  loadedShortId,
  loadedAid,
  loadedUuid,
  currentShortId,
  currentAid,
  currentUuid,
}: DataLoadContextParams): boolean {
  return (
    loadedShortId === (currentShortId || null) &&
    loadedAid === currentAid &&
    loadedUuid === currentUuid
  );
}

export function shouldRunDataLoad({
  initData,
  shortId,
  hasSurveyData,
  loadedShortId,
  loadedAid,
  loadedUuid,
  currentAid,
  currentUuid,
  isRunInFlight,
}: ShouldRunDataLoadParams): boolean {
  if (!initData || !shortId || isRunInFlight) {
    return false;
  }

  if (!hasSurveyData) {
    return true;
  }

  const hasContextChanged = !isSameDataLoadContext({
    loadedShortId,
    loadedAid,
    loadedUuid,
    currentShortId: shortId,
    currentAid,
    currentUuid,
  });

  return hasContextChanged;
}
